import { render, staticRenderFns } from "./ProcessFrequency.vue?vue&type=template&id=ad173d36&scoped=true&"
import script from "./ProcessFrequency.vue?vue&type=script&lang=js&"
export * from "./ProcessFrequency.vue?vue&type=script&lang=js&"
import style0 from "./ProcessFrequency.vue?vue&type=style&index=0&id=ad173d36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad173d36",
  null
  
)

export default component.exports